import ChipTagMenu from './ChipTagMenu'

export default ChipTagMenu
